import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/main'
import PerfectInfo from '@/view/perfectInfo/perfectInfo'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/login',
    name: '登陆',
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/register',
    name: '注册',
    component: () => import('@/view/register/register')
  },
  {
    path: '/resetPassword',
    name: '重置密码',
    component: () => import('@/view/resetPassword/resetPassword')
  },
  {
    path: '/bindMobile',
    name: '绑定手机号',
    component: () => import('@/view/bindMobile/bindMobile')
  },
  {
    path: '/404',
    name: '404页面',
    component: Main,
    children: [
      {
        path: '/404',
        name: '页面找不到啦~',
        component: () => import('@/view/errorPage/404'),
        meta: {
          name: '页面丢失'
        }
      }
    ]
  },
  {
    path: '/500',
    name: '500页面',
    component: Main,
    children: [
      {
        path: '/500',
        name: '页面出错啦~',
        component: () => import('@/view/errorPage/500'),
        meta: {
          name: '页面出错'
        }
      }
    ]
  },
  {
    path: '/',
    redirect: '/home',
    component: Main,
    children: [
      {
        path: '/home',
        name: '工作台',
        component: () => import('@/components/home/home.vue'),
        meta: {
          type: '菜单',
          name: '工作台',
          parentMenu: 'home:-'
        }
      },
      {
        path: '/waitting',
        name: '待开发',
        component: () => import('@/view/waitting/waitting.vue')
      }
    ]
  },
  {
    path: '/',
    name: '完善资料',
    component: PerfectInfo,
    children: [
      {
        path: '/perfectInfo',
        name: '完善资料-请选择',
        component: () => import('@/view/perfectInfo/infoChoose.vue')
      },
      {
        path: '/perfectInfo/investigator',
        name: '完善资料-调查员团队',
        component: () => import('@/view/perfectInfo/investigatorInfo.vue')
      }
    ]
  },
  {
    path: '/',
    name: '个人中心',
    component: Main,
    children: [
      {
        path: '/personalCenter/information',
        name: '账号管理',
        component: () => import('@/view/personalCenter/information.vue')
      }
    ]
  }
]

export const asyncRoutes = [
  {
    path: '/',
    name: '成员管理',
    component: Main,
    children: [
      {
        path: '/memberManage/memberManage',
        name: '成员管理',
        component: () => import('@/view/memberManage/memberManage.vue'),
        meta: {
          type: '菜单',
          name: '成员管理',
          parentMenu: 'staff:-'
        }
      },
      {
        path: '/memberManage/memberGroupManage',
        name: '成员组管理',
        component: () => import('@/view/memberManage/memberGroupManage.vue'),
        meta: {
          type: '菜单',
          name: '成员组管理',
          parentMenu: 'staff:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '任务大厅',
    component: Main,
    children: [
      {
        path: '/taskHall/publicTask',
        name: '公共任务',
        component: () => import('@/view/taskHall/publicTask/publicTask.vue'),
        meta: {
          type: '菜单',
          name: '公共任务',
          parentMenu: 'mission:-'
        }
      },
      {
        path: '/taskHall/designateTask',
        name: '指派任务',
        component: () => import('@/view/taskHall/designateTask/designateTask.vue'),
        meta: {
          type: '菜单',
          name: '指派任务',
          parentMenu: 'mission:-'
        }
      },
      {
        path: '/taskHall/myTask',
        name: '我的任务',
        component: () => import('@/view/taskHall/myTask/myTask.vue'),
        meta: {
          type: '菜单',
          name: '我的任务',
          parentMenu: 'mission:-'
        }
      },
      {
        path: '/taskHall/allTasks',
        name: '全部任务',
        component: () => import('@/view/taskHall/allTasks/allTasks.vue'),
        meta: {
          type: '菜单',
          name: '全部任务',
          parentMenu: 'mission:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '线索',
    component: Main,
    children: [
      {
        path: '/clue/myClue',
        name: '我的线索',
        component: () => import('@/view/clue/myClue/myClue.vue'),
        meta: {
          type: '菜单',
          name: '我的线索',
          parentMenu: 'clue:-'
        }
      },
      {
        path: '/clue/allClues',
        name: '全部线索',
        component: () => import('@/view/clue/allClues/allClues.vue'),
        meta: {
          type: '菜单',
          name: '全部线索',
          parentMenu: 'clue:-'
        }
      },
      {
        path: '/clue/regionConfig',
        name: '区域等级查询',
        component: () => import('@/view/clue/regionConfig/regionConfig.vue'),
        meta: {
          type: '菜单',
          name: '区域等级配置',
          parentMenu: 'clue:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '外部线索报审',
    component: Main,
    children: [
      {
        path: '/clue/preReport',
        name: '线索预审',
        component: () => import('@/view/clue/preReport/index.vue'),
        meta: {
          type: '菜单',
          name: '线索预审',
          parentMenu: 'clue:-'
        }
      },
      {
        path: '/clue/allReport',
        name: '全部线索',
        component: () => import('@/view/clue/allReport/index.vue'),
        meta: {
          type: '菜单',
          name: '全部线索',
          parentMenu: 'clue:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '民事案件',
    component: Main,
    children: [
      {
        path: '/case/civilCase',
        name: '普通案件',
        component: () => import('@/view/case/civilCase.vue'),
        meta: {
          type: '菜单',
          name: '普通案件',
          parentMenu: 'case:-'
        }
      },
      {
        path: '/case/obtainEvidenceCase',
        name: '取证案件',
        component: () => import('@/view/case/obtainEvidenceCase.vue'),
        meta: {
          type: '菜单',
          name: '取证案件',
          parentMenu: 'case:-'
        }
      },
      {
        path: '/case/seriousCase',
        name: '重案案件',
        component: () => import('@/view/case/seriousCase.vue'),
        meta: {
          type: '菜单',
          name: '重案案件',
          parentMenu: 'case:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '行政案件',
    component: Main,
    children: [
      {
        path: '/case/administrativeCase',
        name: '行政案件',
        component: () => import('@/view/case/administrativeCase.vue'),
        meta: {
          type: '菜单',
          name: '行政案件',
          parentMenu: 'case:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '刑事案件',
    component: Main,
    children: [
      {
        path: '/case/criminalCase',
        name: '刑事案件',
        component: () => import('@/view/case/criminalCase.vue'),
        meta: {
          type: '菜单',
          name: '刑事案件',
          parentMenu: 'case:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '案件管理',
    component: Main,
    children: [
      {
        path: '/case/allCases',
        name: '全部案件',
        component: () => import('@/view/case/allCases.vue'),
        meta: {
          type: '菜单',
          name: '全部案件',
          parentMenu: 'case:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '已转出案件',
    component: Main,
    children: [
      {
        path: '/case/transferredCases',
        name: '已转出案件',
        component: () => import('@/view/case/transferredCases.vue'),
        meta: {
          type: '菜单',
          name: '已转出案件',
          parentMenu: 'case:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '电子固证信息',
    component: Main,
    children: [
      {
        path: '/case/fxNotary',
        name: '电子固证信息',
        component: () => import('@/view/case/fxNotary.vue'),
        meta: {
          type: '菜单',
          name: '电子固证信息',
          parentMenu: 'case:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '案件信息批量处理',
    component: Main,
    children: [
      {
        path: '/case/batchProcess',
        name: '案件信息批量处理',
        component: () => import('@/view/caseBatchProcess/index.vue'),
        meta: {
          type: '菜单',
          name: '案件信息批量处理',
          parentMenu: 'case:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '回购结算管理',
    component: Main,
    children: [
      {
        path: '/settlement/unsettledCase',
        name: '待结算案件',
        component: () => import('@/view/settlement/unsettledCase/index.vue'),
        meta: {
          type: '菜单',
          name: '待结算案件',
          parentMenu: 'settlement:-'
        }
      },
      {
        path: '/settlement/statementManagement',
        name: '结算单管理',
        component: () => import('@/view/settlement/statementManagement/index.vue'),
        meta: {
          type: '菜单',
          name: '结算单管理',
          parentMenu: 'settlement:-'
        }
      },
      {
        path: '/settlement/refundManagement',
        name: '退款管理',
        component: () => import('@/view/settlement/refundManagement/index.vue'),
        meta: {
          type: '菜单',
          name: '退款管理',
          parentMenu: 'settlement:-'
        }
      },
      {
        path: '/settlement/collectionRecord',
        name: '收款记录',
        component: () => import('@/view/settlement/collectionRecord/index.vue'),
        meta: {
          type: '菜单',
          name: '收款记录',
          parentMenu: 'settlement:-'
        }
      },
      {
        path: '/settlement/mailingList',
        name: '邮寄列表',
        component: () => import('@/view/settlement/mailingList/index.vue'),
        meta: {
          type: '菜单',
          name: '邮寄列表',
          parentMenu: 'settlement:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '报酬结算管理',
    component: Main,
    children: [
      {
        path: '/reward/settlement/unsettledCase',
        name: '待结算案件',
        component: () => import('@/view/rewardStatement/unsettledCase/index.vue'),
        meta: {
          type: '菜单',
          name: '报酬-待结算案件',
          parentMenu: 'settlement:-'
        }
      },
      {
        path: '/reward/settlement/statementManagement',
        name: '结算单管理',
        component: () => import('@/view/rewardStatement/statementManagement/index.vue'),
        meta: {
          type: '菜单',
          name: '报酬-结算单管理',
          parentMenu: 'settlement:-'
        }
      },
      {
        path: '/reward/settlement/collectionRecord',
        name: '收款记录',
        component: () => import('@/view/rewardStatement/collectionRecord/index.vue'),
        meta: {
          type: '菜单',
          name: '报酬-收款记录',
          parentMenu: 'settlement:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '项目',
    component: Main,
    children: [
      {
        path: '/project/list',
        name: '项目列表',
        component: () => import('@/view/project/project.vue'),
        meta: {
          type: '菜单',
          name: '项目列表',
          parentMenu: 'project:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '系统设置',
    component: Main,
    children: [
      {
        path: '/settings/teamInfo',
        name: '团队信息',
        component: () => import('@/view/settings/teamInfo.vue'),
        meta: {
          type: '菜单',
          name: '团队信息',
          parentMenu: 'system:-'
        }
      },
      {
        path: '/settings/authority',
        name: '权限管理',
        component: () => import('@/view/settings/authority.vue'),
        meta: {
          type: '菜单',
          name: '权限管理',
          parentMenu: 'system:-'
        }
      },
      {
        path: '/settings/bankCardAccount',
        name: '银行卡账户',
        component: () => import('@/view/settings/bankCardAccount.vue'),
        meta: {
          type: '菜单',
          name: '银行卡账户',
          parentMenu: 'system:-'
        }
      },
      {
        path: '/settings/mailingAddress',
        name: '邮寄地址',
        component: () => import('@/view/settings/mailingAddress.vue'),
        meta: {
          type: '菜单',
          name: '邮寄地址',
          parentMenu: 'system:-'
        }
      },
      {
        path: '/settings/orgChange',
        name: '机构变更',
        component: () => import('@/view/settings/orgChange.vue'),
        meta: {
          type: '菜单',
          name: '机构变更',
          parentMenu: 'system:-'
        }
      },
      {
        path: '/settings/noticeBank',
        name: '公告栏',
        component: () => import('@/view/settings/noticeBank.vue'),
        meta: {
          type: '菜单',
          name: '公告栏',
          parentMenu: 'system:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '权属查询',
    component: Main,
    children: [
      {
        path: '/tools/trademark',
        name: '商标查询',
        component: () => import('@/view/tools/trademark/index.vue'),
        meta: {
          type: '菜单',
          name: '商标查询',
          parentMenu: 'tools:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '侵权监测',
    component: Main,
    children: [
      {
        path: '/tools/infringementMonitoring/oldOnlineMonitor',
        name: '线上监测（旧版）',
        component: () => import('@/view/tools/infringementMonitoring/onlineMonitor/index.vue'),
        meta: {
          type: '菜单',
          name: '线上监测（旧版）',
          parentMenu: 'tools:-'
        }
      },
      {
        path: '/tools/infringementMonitoring/onlineMonitor',
        name: '线上监测',
        component: () => import('@/view/tools/infringementMonitoring/newOnlineMonitor/index.vue'),
        meta: {
          type: '菜单',
          name: '线上监测',
          parentMenu: 'tools:-'
        }
      },
      {
        path: '/tools/infringementMonitoring/offlineMonitor',
        name: '线下监测',
        component: () => import('@/view/tools/infringementMonitoring/offlineMonitor/index.vue'),
        meta: {
          type: '菜单',
          name: '线下监测',
          parentMenu: 'tools:-'
        }
      }
    ]
  }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js